import { createStore, combineReducers, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import alertComponentReducer from "./alert/reducer";
import loadingtComponentReducer from "./loading/reducer";

import globalReducer from "./global/reducer";
import customerInformationsReducer from "./customerInformation/reducer";
import limitAndPaymentInformationReducer from "./limitAndPaymentInformation/reducer";
import processContextReducer from "./processContext/reducer";
import documentReducer from "./document/reducer";

import unsuccessComponentReducer from "./unsuccess/reducer";
import acceptanceComponentReducer from "./acceptance/reducer";


export default () => {
  const store = createStore(
    combineReducers({
      global:globalReducer,
      customerInformations: customerInformationsReducer,
      document:documentReducer,
      limitAndPaymentInformation: limitAndPaymentInformationReducer,
      alert:alertComponentReducer,
      loading:loadingtComponentReducer,
      processContext:processContextReducer,
      unsuccess:unsuccessComponentReducer,
      acceptance:acceptanceComponentReducer,
    }),
    applyMiddleware(thunk)
  );
  
  return store;
};


/*


export const store = createStore({
  reducer: {
    layout: layoutReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (gDM) =>
    gDM({
      serializableCheck: false,
      devTools: {},
    }).concat(baseApi.middleware),
})

*/